export var ACTIVE_TEXT_BUTTON_COLOR = 'white';
export var DISABLED_CLOSE_BUTTON_COLOR = 'grey-300';
export var ENABLED_CLOSE_BUTTON_COLOR = 'grey-700';